// tslint:disable-next-line:max-line-length
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ICustomer, ILedger } from './customer.class';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector: 'app-customer-ledger',
    templateUrl: 'customerLedger.component.html',
    styleUrls: ['customerLedger.component.css']
})

export class CustomerLedgerComponent implements OnInit, OnChanges
{
    ledgers: ILedger[];
    loading = false;

    @Input() selectedCustomer: ICustomer;

    constructor(private customerService: CustomerService)
    {
    }

    private getLedger()
    {
        this.customerService.getCustomerLedger(this.selectedCustomer.customerId)
        .then(response =>
        {
            this.ledgers = response;
        });
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (changes['selectedCustomer']) {
            this.getLedger();
        }
    }

    ngOnInit()
    {
        this.getLedger();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Customer/customerLedger.component.ts